exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidebar{flex:1;min-height:calc(100vh - 120px);background-color:#4f5962}.sidebar-links li{color:#fff;padding:10px;border-bottom:2px solid #444242;list-style-type:none}.sidebar-links li:hover{background-color:rgba(194,199,208,.2);color:#fff;cursor:pointer}.activeAdmin,.collapsible:hover{background-color:#ccc}.content-collapsible{padding:0 18px;max-height:0;overflow:hidden;transition:max-height .2s ease-out;background-color:#4f5962}.form{color:#fff;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32754bde","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin/Sidebar.vue
// module id = 646
// module chunks = 2